import { useCallback, useState } from 'react';

export function useDataValidator(schema) {
  const [validData, setValidData] = useState([]);
  const [errors, setErrors] = useState([]);

  const validateData = useCallback(
    async rows => {
      if (!rows?.length) {
        setErrors(["The file shouldn't be empty."]);
        setValidData([]);
        return;
      }

      const validRows = [];
      const rowErrors = [];

      for (let i = 0; i < rows.length; i++) {
        try {
          const validated = await schema.validate(rows[i], { abortEarly: false });
          validRows.push(validated);
        } catch (err) {
          rowErrors.push({ row: i + 2, errors: err.errors });
        }
      }

      setValidData(validRows);
      setErrors(rowErrors);
    },
    [schema]
  );

  return { validData, errors, validateData };
}
